var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PluginInstallParamsBuilder"},[(_vm.isInPreview)?_c('PluginInstallParamsPreview',{attrs:{"categories":_vm.categories}}):_c('div',[(!_vm.editingElement)?_c('PluginInstallParamsMainView'):_c('PluginInstallParamsElementDetail')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }